var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.768 8.35899C12.6709 8.25158 12.5524 8.16572 12.4202 8.10695C12.2879 8.04819 12.1447 8.01782 12 8.01782C11.8552 8.01782 11.7121 8.04819 11.5798 8.10695C11.4475 8.16572 11.329 8.25158 11.232 8.35899L6.23197 14.359C6.11006 14.505 6.0323 14.6827 6.00783 14.8713C5.98335 15.0599 6.01317 15.2516 6.09379 15.4239C6.17442 15.5961 6.30249 15.7418 6.46299 15.8439C6.6235 15.9459 6.80978 16.0001 6.99997 16H17C17.1902 16.0001 17.3764 15.9459 17.5369 15.8439C17.6975 15.7418 17.8255 15.5961 17.9061 15.4239C17.9868 15.2516 18.0166 15.0599 17.9921 14.8713C17.9676 14.6827 17.8899 14.505 17.768 14.359L12.768 8.35899Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.19155e8efa40efdcb923d7c4e49ed286.svg";
export { ForwardRef as ReactComponent };